<admin-page-simple-content
    [pageError]="pageError"
    [pageStatus]="pageStatus"
    [title]="'Settings: External Photo Sources'"
    [icon]="'photos'"
>
    <div class="content">
        @if (pageStatus === "saveError") {
            <admin-error [error]="pageError"></admin-error>
        }
        <h2>Settings</h2>
        <mat-card>

            <div class="config-checkbox">
                <mat-checkbox [(ngModel)]="photoSourceBasicSettings.isPastUploadsEnabled" name="isPastUploadsEnabled">
                    Past uploads
                </mat-checkbox>
                <span class="mat-caption">Shows the "Past Uploads" photo source in Mediaclip Designer.</span>
                <div class="config-checkbox ml-32 child-config-checkbox">
                    <mat-checkbox [(ngModel)]="photoSourceBasicSettings.isRecentUploadsEnabled" name="isRecentUploadsEnabled">
                        Recent uploads
                    </mat-checkbox>
                    <span class="mat-caption">Shows the "Recent Uploads" album in Mediaclip Designer.</span>
                </div>
            </div>

            <div class="config-checkbox">
                <mat-checkbox [(ngModel)]="photoSourceBasicSettings.isExternalUploaderEnabled" name="isExternalUploaderEnabled">
                    External Uploader
                </mat-checkbox>
                <span
                    class="mat-caption">Shows the "Upload from your phone" photo source in Mediaclip Designer. (Upload with a QR code)</span>
                <span class="mat-caption">The External Uploader Page endpoint must be defined (<a
                    [routerLink]="['/stores', storeId, 'settings', 'endpoints']">To configure</a>)</span>
            </div>
            <mat-card-actions align="end">
                <admin-save-button [pageStatus]="pageStatus" (save)="saveBasicSettings()"> Save</admin-save-button>
            </mat-card-actions>
        </mat-card>
        <mat-accordion>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <h2>Built-in external photo sources ({{ builtInExternalPhotoSources.length }})</h2>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                @for (source of builtInExternalPhotoSources; track source) {
                    <mat-card class="photo-source-card" [attr.data-photoSourceId]="source.photoSourceId">
                        <mat-card-header>
                            <mat-card-title>{{ source.label }}</mat-card-title>
                            <mat-card-subtitle><code adminCopyToClipboard>{{ source.photoSourceId }}</code></mat-card-subtitle>
                            <div mat-card-avatar class="source-img">
                                @if (source.icon) {
                                    <img alt="" [src]="source.icon" />
                                }
                            </div>
                            <span class="padding"></span>
                            <photo-source-actions-menu
                                [enabled]="source.status === 'Enabled'"
                                [enableAction]="enableBuiltInPhotoSource.bind(this, source)"
                                [disableAction]="disableBuiltInPhotoSource.bind(this, source)"
                                [editAction]="openBuiltInPhotoSourceEditor.bind(this, source.photoSourceId)"
                                [deleteAction]="deleteBuiltInPhotoSource.bind(this, source)">
                            </photo-source-actions-menu>
                        </mat-card-header>
                        <mat-card-content>
                            @if (source.details) {
                                <p class="mat-body">
                                    <mat-icon color="warn">warning</mat-icon>
                                    {{ source.details }}
                                </p>
                            }
                            <div class="properties">
                                <h2 class="mat-h2">Config</h2>
                                <span>State</span>
                                <span class
                                ><code>{{ source.status }}</code></span
                                >
                                @if (source.status === "Disabled") {
                                    <span class="prop-warn"
                                    ><mat-icon color="warn">warning</mat-icon>
                                        This source will not be listed in the designer until it's enabled
                                    </span>
                                }
                                <span>App Id</span>
                                <span
                                ><code adminCopyToClipboard>{{ source.appId }}</code></span
                                >
                            </div>
                        </mat-card-content>
                    </mat-card>
                }
                <div class="create-photo-source-list">
                    @for (info of builtinsExternalPhotoSourceDefinitions; track info) {
                        @if (!isProviderExistsForStore(info.providerId)) {
                            <button
                                mat-stroked-button
                                color="primary"
                                (click)="openAddBuiltInPhotoSourceEditor(info.providerId)"
                            >
                                <span class="label">
                                    <img alt="Photo source logo" src="{{ info.iconUrl }}" />
                                    <span>Configure {{ info.label }} photo source</span>
                                </span>
                            </button>
                        }
                    }
                </div>
            </mat-expansion-panel>
        </mat-accordion>
        <mat-accordion>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <h2>Generic external photo sources ({{ genericExternalPhotoSources.length }})</h2>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                @for (source of genericExternalPhotoSources; track source) {
                    <mat-card class="photo-source-card" [attr.data-photoSourceId]="source.photoSourceId">
                        <mat-card-header>
                            <mat-card-title>{{ source.label }}</mat-card-title>
                            <mat-card-subtitle><code adminCopyToClipboard>{{ source.photoSourceId }}</code></mat-card-subtitle>
                            <div mat-card-avatar class="source-img">
                                @if (source.icon) {
                                    <img alt="Photo source logo" [src]="source.icon" />
                                }
                            </div>
                            <span class="padding"></span>
                            <photo-source-actions-menu
                                [enabled]="source.status === 'Enabled'"
                                [enableAction]="enableGenericPhotoSource.bind(this, source)"
                                [disableAction]="disableGenericPhotoSource.bind(this, source)"
                                [editAction]="editGenericExternalPhotoSource.bind(this, source)"
                                [deleteAction]="deleteGenericPhotoSource.bind(this, source)">
                            </photo-source-actions-menu>
                        </mat-card-header>
                        <mat-card-content>
                            @if (source.details) {
                                <p class="mat-body">
                                    <mat-icon color="warn">warning</mat-icon>
                                    {{ source.details }}
                                </p>
                            }
                            <div class="properties">
                                <h2 class="mat-h2">Config</h2>
                                <span>State</span>
                                <span class
                                ><code>{{ source.status }}</code></span
                                >
                                @if (source.status === "Disabled") {
                                    <span class="prop-warn"
                                    ><mat-icon color="warn">warning</mat-icon>
                                This source will not be listed in the designer until it's enabled
                            </span>
                                }
                                <span>App Id</span>
                                <span
                                ><code adminCopyToClipboard>{{ source.appId }}</code></span
                                >
                                <span>Scopes</span>
                                <span
                                ><code adminCopyToClipboard>{{ source.scopes }}</code></span
                                >
                                <h2 class="mat-h2">Endpoints</h2>
                                <span>Authorization url</span>
                                <span
                                ><code adminCopyToClipboard>{{ source.authorizationUrl }}</code></span
                                >
                                <span>Token url</span>
                                <span
                                ><code adminCopyToClipboard>{{ source.tokenUrl }}</code></span
                                >
                                <span>Album url</span>
                                <span
                                ><code adminCopyToClipboard>{{ source.albumUrl }}</code></span
                                >
                                <span>Photo url</span>
                                <span
                                ><code adminCopyToClipboard>{{ source.photoUrl }}</code></span
                                >
                            </div>
                        </mat-card-content>
                    </mat-card>
                }
                <div class="add-source-action">
                    <button
                        mat-stroked-button
                        color="primary"
                        (click)="openAddGenericExternalPhotoSourceDialog()"
                        class="add-source-button"
                    >
                        <mat-icon>add</mat-icon>
                        Add a generic external photo source
                    </button>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
        <mat-accordion>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <h2>Stock photo sources ({{ stockPhotoSources.length }})</h2>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                @for (source of stockPhotoSources; track source) {
                    <mat-card class="photo-source-card" [attr.data-id]="source.id">
                        <mat-card-header>
                            @let defaultLabel = labelTranslations()[getStockPhotoLocalizationKey(source)]['en'];
                            @if (defaultLabel ?? source.label) {
                                <mat-card-title>{{ defaultLabel ?? source.label }}</mat-card-title>
                            }
                            <mat-card-subtitle><code adminCopyToClipboard>{{ source.id }}</code></mat-card-subtitle>
                            <div mat-card-avatar class="source-img">
                                @if (source.thumbnailUrl) {
                                    <img alt="Photo source logo" [src]="source.thumbnailUrl" />
                                }
                            </div>
                            <span class="padding"></span>
                            @if (canManageStockPhotoSource()) {
                                <photo-source-actions-menu
                                    [enabled]="!source.disabled"
                                    [editAction]="editStockPhotoSource.bind(this, source)"
                                    [deleteAction]="deleteStockPhotoSource.bind(this, source)"
                                    [translateAction]="translateStockPhotoSource.bind(this, source)">
                                </photo-source-actions-menu>
                            }
                        </mat-card-header>
                        <mat-card-content>
                            <div class="properties">
                                <h2 class="mat-h2">Config</h2>
                                <span>State</span>
                                <span
                                ><code>{{ source.disabled ? "disabled" : "enabled" }}</code></span
                                >
                                @if (source.disabled) {
                                    <span class="prop-warn">
                                <mat-icon color="warn">warning</mat-icon>
                                This source will not be listed in the designer until it's enabled
                            </span>
                                }
                                @if (canManageStockPhotoSource()) {
                                    <h2 class="mat-h2">Endpoints</h2>
                                    <span>Thumbnail url</span>
                                    <span
                                    ><code adminCopyToClipboard>{{ source.thumbnailUrl }}</code></span
                                    >
                                    <span>Photos url</span>
                                    <span
                                    ><code adminCopyToClipboard>{{ source.photosEndpoint.url }}</code></span
                                    >
                                    <span>Albums url</span>
                                    <span
                                    ><code adminCopyToClipboard>{{ source.albumsEndpoint?.url }}</code></span
                                    >
                                }
                            </div>
                        </mat-card-content>
                    </mat-card>
                }
                @if (canManageStockPhotoSource()) {
                    <div class="add-source-action">
                        <button
                            mat-stroked-button
                            color="primary"
                            (click)="openStockPhotoSourceAddDialog()"
                            class="add-source-button"
                        >
                            <mat-icon>add</mat-icon>
                            Add a stock photo source
                        </button>
                    </div>
                }
            </mat-expansion-panel>
        </mat-accordion>
        <mat-accordion>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <h2>Direct photo sources ({{ directPhotoSources.length }})</h2>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                @for (source of directPhotoSources; track source) {
                    <mat-card class="photo-source-card" [attr.data-id]="source.name">
                        <mat-card-header>
                            <mat-card-title>{{ source.name }}</mat-card-title>
                            <mat-card-subtitle><code adminCopyToClipboard>{{ source.name }}</code></mat-card-subtitle>
                            <span class="padding"></span>
                            @if (canManageStockPhotoSource()) {
                                <photo-source-actions-menu
                                    [enabled]="true"
                                    [editAction]="openDirectPhotoSourceEditor.bind(this, source.name)">
                                </photo-source-actions-menu>
                            }
                        </mat-card-header>
                        <mat-card-content>
                            <div class="properties">
                                @if (canManageStockPhotoSource()) {
                                    <h3 class="mat-h2">Endpoints</h3>
                                    <span>Photos url</span>
                                    <span>
                                        <code adminCopyToClipboard>{{ source.photoEndpoint.url }}</code>
                                    </span>
                                }
                            </div>
                        </mat-card-content>
                    </mat-card>
                }
                <div class="add-source-action">
                    <button
                        mat-stroked-button
                        color="primary"
                        (click)="openDirectPhotoSourceAddDialog()"
                        class="add-source-button"
                    >
                        <mat-icon>add</mat-icon>
                        Add a direct photo source
                    </button>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
        <mat-accordion>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <h2>Session photo sources ({{ sessionPhotoSources.length }})</h2>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                @for (source of sessionPhotoSources; track source) {
                    <mat-card class="photo-source-card" [attr.data-id]="source.name">
                        <mat-card-header>
                            @let defaultLabel = labelTranslations()[getSessionPhotoLocalizationKey(source)]['en'];
                            @if (defaultLabel) {
                                <mat-card-title>{{ defaultLabel }}</mat-card-title>
                            }
                            <mat-card-subtitle><code adminCopyToClipboard>{{ source.name }}</code></mat-card-subtitle>
                            <div mat-card-avatar class="source-img">
                                @if (source.thumbnailUrl) {
                                    <img alt="Photo source logo" [src]="source.thumbnailUrl" />
                                }
                            </div>
                            <span class="padding"></span>
                            <photo-source-actions-menu
                                [enabled]="source.enabled"
                                [disableAction]="disableSessionPhotoSource.bind(this, source)"
                                [enableAction]="enableSessionPhotoSource.bind(this, source)"
                                [editAction]="openSessionPhotoSourceEditor.bind(this, source.name)">
                            </photo-source-actions-menu>
                        </mat-card-header>
                        <mat-card-content>
                            <div class="properties">
                                <h2 class="mat-h2">Config</h2>
                                <span>State</span>
                                <span
                                ><code>{{ source.enabled ? "enabled" : "disabled" }}</code></span
                                >
                                @if (!source.enabled) {
                                    <span class="prop-warn">
                                <mat-icon color="warn">warning</mat-icon>
                                This source will not be listed in the designer until it's enabled
                            </span>
                                }
                                <span>Thumbnail url</span>
                                <span>
                                    <code adminCopyToClipboard>{{ source.thumbnailUrl }}</code>
                                </span>
                            </div>
                        </mat-card-content>
                    </mat-card>
                }
                <div class="add-source-action">
                    <button
                        mat-stroked-button
                        color="primary"
                        (click)="openSessionPhotoSourceAddDialog()"
                        class="add-source-button"
                    >
                        <mat-icon>add</mat-icon>
                        Add a session photo source
                    </button>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
    </div>
</admin-page-simple-content>
